import { useContext } from "react";
import { useConnectAccountRequest } from "src/services/link/commands/connect-account";
import { useResetConnectionRequest } from "src/services/link/commands/reset-connection";
import { useUpdateConnectionRequest } from "src/services/link/commands/update-connection";

import ThemeContext from "../../Products/context";
import Context from "../context";

export default function useGetConnectUpdateService() {
	const { customConnectProps } = useContext(Context);
	const { state } = useContext(ThemeContext);
	const { updateToken, restoreToken } = customConnectProps!;

	const { mutate } = updateToken
		? useUpdateConnectionRequest(updateToken, state.authToken)
		: restoreToken
		? useResetConnectionRequest(restoreToken, state.authToken)
		: useConnectAccountRequest(state.authToken);

	return { mutate };
}
